module.exports = __webpack_public_path__ + "static/media/60.cf205011.svg";